export enum EFilterSpecOperator {
	everywhere = '%x%'
}